import { Navigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import {
  AccountSecurityPage,
  BillingPage,
  CompanyInformationPage,
  EmployerDisclaimersPageEMPAdmin,
  GeneralBillingRulesPage,
  InitialBillingRulesPage,
  NotificationsSettingsPage,
  PersonalInformationPage,
  PrivacySettingsPage,
  SettingsPage,
  SetupMfaPage,
  VerificationPurposesPage,
  WalletAccountPage,
} from 'src/pages';
import type { RouteProps } from 'src/types/router';

import { AccountOutlet } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <Navigate to={appRoutes.account.personalInformation} />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.account.personalInformation,
    element: <PersonalInformationPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.account.privacySettings,
    element: <PrivacySettingsPage />,
    accessRoles: [ReactRouteAccessKey.isEmployee],
  },
  {
    path: appRoutes.account.companyInformation,
    element: <CompanyInformationPage />,
    accessRoles: [
      BusinessRole.VerifierAdmin,
      BusinessRole.EmployerAdmin,
      BusinessRole.PeoSuperAdmin,
      BusinessRole.PeoAdmin,
      BusinessRole.PeoPayrollProviderUser,
    ],
  },
  {
    path: appRoutes.account.employerDisclaimer,
    element: <EmployerDisclaimersPageEMPAdmin />,
    accessRoles: [BusinessRole.EmployerAdmin],
  },
  {
    path: appRoutes.account.generalBillingRules,
    element: <GeneralBillingRulesPage />,
    accessRoles: [BusinessRole.PlatformAdmin],
  },
  {
    path: appRoutes.account.notifications,
    element: <NotificationsSettingsPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.account.wallet,
    element: <WalletAccountPage />,
    accessRoles: [
      BusinessRole.EmployerAdmin,
      BusinessRole.PeoSuperAdmin,
      BusinessRole.PeoAdmin,
      BusinessRole.PeoPayrollProviderUser,
    ],
  },
  {
    path: appRoutes.account.security,
    element: <AccountSecurityPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.account.settings,
    element: <SettingsPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.account.billing,
    element: <BillingPage />,
    accessRoles: [BusinessRole.VerifierAdmin, BusinessRole.VerifierManager],
  },
  {
    path: appRoutes.account.verificationPurposes,
    element: <VerificationPurposesPage />,
    accessRoles: [BusinessRole.VerifierAdmin],
  },
  {
    path: appRoutes.account.billingSettings,
    element: <InitialBillingRulesPage />,
    accessRoles: [BusinessRole.PlatformAdmin],
  },
  {
    path: appRoutes.account.setupMfa,
    element: <SetupMfaPage />,
    accessRoles: [ReactRouteAccessKey.anyAuthorized],
  },
];

export const ACCOUNT_ROUTE: RouteProps = {
  path: appRoutes.account.index,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
  element: <AccountOutlet />,
  childRoutes: ROUTES,
};
